import { render } from "./NewOrderForklift.vue?vue&type=template&id=970d0860&scoped=true"
import script from "./NewOrderForklift.vue?vue&type=script&lang=js"
export * from "./NewOrderForklift.vue?vue&type=script&lang=js"

import "./NewOrderForklift.vue?vue&type=style&index=0&id=970d0860&lang=css"
import "./NewOrderForklift.vue?vue&type=style&index=1&id=970d0860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-970d0860"]])

export default __exports__